import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextFormatStrikethrough16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconTextFormatStrikethrough16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4 2h9v1.5a.5.5 0 0 1-1 0V3H9v3a.5.5 0 0 1-1 0V3H5v.5a.5.5 0 0 1-1 0zm5 9a.5.5 0 0 0-1 0v2H6.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H9zM5 8a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextFormatStrikethrough16);
